<template>
  <div id="app">
    <h2 id="editor" ref="editor">Vendor Info</h2>
    <div id="iframe-wrapper" :style="iframe.wrapperStyle">
      <iframe
        v-if="loaded"
        :src="fileURL"
        :style="iframe.style"
        :height="'100vh'"
        :width="iframe.style.width"
        type="application/pdf"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { apiConfig } from "../services/config";
export default {
  data() {
    return {
      loaded: false,
      iframe: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
    };
  },
  computed: {
    fileURL() {
      
      return `${apiConfig}/api/Blob/GetVendorInfo`;
    },
  },
  mounted() {
    let editor = this.$refs.editor;
    this.iframe.style = {
      position: "absolute",
      width: "93%",
      height: "100vh",
      top: "2rem",
      left: 0,
      margin: "3rem",
    };
    this.iframe.wrapperStyle = {
      overflow: "hidden",
      height: "100vh",
      width: editor.clientWidth + "px",
    };
    this.loaded = true;
  },
  
};
</script>
